import React, { useEffect, useState } from 'react';
import { database } from '../../../utils/firebase';
import ReactExport from "react-export-excel";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const SavedMembers = ( {eventID, userID}) => {
    const [usersData, setUsersData] = useState('')
    const [centerDetails, setCenterDetails] = useState([])
    const [btnState, setBtnState] = useState(false)

    useEffect(() => {
        if(usersData){
            setBtnState(false)
            setCenterDetails([
                {
                    name: usersData.centerName.split(' ').filter(el => el.length > 0).map(el => {
                        return el[0].toUpperCase() + el.slice(1).toLowerCase()
                        }).join(' '),
                    country: usersData.centerCountry
                  
                }
            ])
        } else {
            setBtnState(true)
        }
    }, [usersData])
   

    useEffect(() => {
        if(eventID && userID) {
            const detailsRef = database.ref('Events').child(eventID).child('Users').child(userID).child('AttendanceReport')
            detailsRef.on('value', (el) => {
                setUsersData(el.val())
            })
        }
    }, [eventID, userID])



    const handleCloseSavedMemPopUp = () => {
        document.querySelector(`.sav${userID}`).classList.add('hide')
        document.querySelector(`.vc${eventID} `).classList.add('hide')
    }

    const handleReportExport = () => {
        function eventFire(el, etype) {
            if (el.fireEvent) {
              el.fireEvent('on' + etype);
            } else {
              var evObj = document.createEvent('Events');
              evObj.initEvent(etype, true, false);
              el.dispatchEvent(evObj);
            }
          }

          const parent = document.querySelector(`.sav${userID}`)
          eventFire(parent.querySelector('span'), 'click');  
    }

    return (
        // Dont use span tag here if at all you can use span1 or span2 never span
        <div className={`saved-mem lang-form-container sav${userID} hide`}>
            <div className="top">
                <h3>Service Attendance</h3>
                <button disabled={btnState} onClick={handleReportExport}>Export Report</button>
            </div>

            <div className="details">

                {usersData? 
                    <>
                        <p>Center: <span1>{usersData.centerName.split(' ').filter(el => el.length > 0).map(el => {
                        return el[0].toUpperCase() + el.slice(1).toLowerCase()
                        }).join(' ')} ({usersData.centerCountry})</span1></p>
                        <p>Submited: <span1>{new Date(usersData.timeStamp).toLocaleString()}</span1></p>
                    </>
                    :
                    <>
                        <p>Center: </p>
                        <p>Submited:</p>
                    </>
                }
                
            </div>
            <div className="form-close" onClick={handleCloseSavedMemPopUp}>
                <i class="fas fa-times"></i>
            </div>
            <div className="table-container">
                <div className="table title">
                    <div className="num dd">#</div>
                    <div className="s-name dd">Name</div>
                    <div className="s-email dd">Email</div>
                    <div className="s-ft dd">First Timer</div>
                    <div className="s-nc dd">New Convert</div>
                    <div className="s-m dd">Member</div>            
                </div>

                {usersData? usersData.userDetails.map((el, i) => {
                    return (
                        <div className="table ">
                            <div className="num dd">{i + 1}</div>
                            <div className="s-name dd">{el.name}</div>
                            <div className="s-email dd">{el.email}</div>
                            <div className="s-ft dd">{el.ft}</div>
                            <div className="s-nc dd">{el.nc}</div>
                            <div className="s-m dd">{el.m}</div> 
                        </div>
                    )
                }) : ''}
               
            </div>  

            <div className="hidden">
                {usersData? 
                    <ExcelFile>
                        <ExcelSheet data={usersData.userDetails} name={`Attendance Report`}>
                            <ExcelColumn label="Name" value="name" />
                            <ExcelColumn label="Email" value="email"/>
                            <ExcelColumn label="Firsttimer" value="ft"/>
                            <ExcelColumn label="New Convert" value="nc"/>
                            <ExcelColumn label="Member" value="m"/>
                        </ExcelSheet>
                        <ExcelSheet data={centerDetails} name="Center Info">
                            <ExcelColumn label="Center Name" value='name'/>
                            <ExcelColumn label="Center Country" value="country"/>
                        </ExcelSheet>
                    </ExcelFile>
                : ''
                }
                
            </div>              
        </div>
    )
}

export default SavedMembers